import { z } from 'zod';

export const sessionCreateSchema = z.object({
  code: z.string().length(4).regex(/^[A-Z2-9]{4}$/, 'Invalid session code format'),
  name: z.string().min(1).max(255).optional(),
  gameMode: z.enum(['teamlab', 'leadlab']),
  language: z.string().length(2).optional(),
  timezone: z.string().max(50).optional(),
  startDate: z.date().optional(),
  notes: z.string().optional(),
  programId: z.number().int().positive().optional(),
  programSlotId: z.number().int().positive().optional(),
});

export const sessionUpdateSchema = sessionCreateSchema.partial().extend({
  isClosed: z.boolean().optional(),
  trainerEmailSent: z.boolean().optional(),
});

export type SessionCreateInput = z.infer<typeof sessionCreateSchema>;
export type SessionUpdateInput = z.infer<typeof sessionUpdateSchema>;
